<template>
    <div component="ImageSlider" :class="{ background: hasBackground }">
        <div class="holder">
            <a v-if="hasGallery" @click="prev" class="button" color="transparent" radius="circle">
                <i class="icon">keyboard_arrow_left</i>
                <span class="text"></span>
            </a>
            <div ref="images" class="wrapper" :direction="direction">
                <img
                    class="img"
                    v-for="(image, index) in images"
                    :key="index"
                    :class="{
                        active: index == getImageSliderIndex,
                        inactive: index == prevIndex,
                    }"
                    :order="index"
                    :src="image.url"
                    :alt="getActor && getActor.meno_priezvisko"
                />
                <img class="img active" v-if="!images || !images.length" :src="getAvatar" />
            </div>
            <a v-if="hasGallery" @click="next" class="button" color="transparent" radius="circle">
                <i class="icon">keyboard_arrow_right</i>
                <span class="text"></span>
            </a>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import avatar_m from '@/assets/avatar.png';
import avatar_f from '@/assets/avatarka.png';

const avatars = {
    m: avatar_m,
    f: avatar_f,
};

export default {
    name: 'ImageSlider',

    props: {
        images: {
            required: true,
        },

        hasBackground: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            direction: 'next',
            prevIndex: null,
        };
    },

    methods: {
        ...mapMutations(['setImageSliderIndex']),

        prev() {
            this.direction = 'prev';
            this.setImageSliderIndex((this.getImageSliderIndex - 1 + this.images.length) % this.images.length);
        },

        next() {
            this.direction = 'next';
            this.setImageSliderIndex((this.getImageSliderIndex + 1) % this.images.length);
        },
    },

    computed: {
        ...mapGetters(['getActor', 'getImageSliderIndex']),

        hasGallery() {
            return this.images.length > 1;
        },

        getAvatar() {
            return avatars[this.getActor?.pohlavie || 'm'];
        },
    },

    watch: {
        getImageSliderIndex(newVal, oldVal) {
            this.direction = newVal > oldVal ? 'next' : 'prev';
            this.prevIndex = oldVal;
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='ImageSlider'] {
    width: 100%;
    position: relative;
    height: 80vw;
    align-items: center;
    display: flex;
    z-index: 55;

    @media (min-width: 768px) {
        height: 100%;
    }

    .holder {
        .flex-center;
        width: 100%;

        .button[radius='circle'] {
            margin-bottom: 0;
            border-width: 0;
        }

        i {
            font-size: 40px;
        }
    }

    .wrapper {
        position: relative;
        width: 80%;
        .radiusCircle;
        overflow: hidden;
        background-color: @white;

        img {
            display: block;
            position: absolute;
            top: 0;
            width: 100%;
            height: auto;
            .radiusCircle;

            &.active {
                position: relative;
                left: 0;
                top: 0;
                transition: 0.7s;
                z-index: 1;
            }

            &.inactive {
                transition: 0.7s;
            }
        }

        &[direction='next'] {
            img {
                left: 100%;
                transform: rotate(90deg);

                &.active {
                    left: 0;
                    transform: rotate(0deg);
                }

                &.inactive {
                    left: -100%;
                    // top: 25%;
                    transform: rotate(-90deg);
                    // transition-delay: 0.1s;
                }
            }
        }

        &[direction='prev'] {
            img {
                left: -100%;
                transform: rotate(-90deg);

                &.active {
                    left: 0%;
                    transform: rotate(0deg);
                }

                &.inactive {
                    left: 100%;
                    transform: rotate(90deg);
                    // top: 25%;
                    // transition-delay: 0.1s;
                }
            }
        }
    }

    &.background {
        &:before {
            content: '' !important;
            position: absolute;
            top: -10px;
            left: -10%;
            height: 105%;
            width: 120%;
            background: linear-gradient(90deg, #afafaf 0%, #f5f5f5 100%);
            z-index: -1;
        }
    }
}
</style>
